import { createStore } from "vuex";

export default createStore({
  state: {
    allBubbles: [],
    authenticated: false,
  },
  getters: {},
  mutations: {
    addBubble(state, bubble) {
      state.allBubbles.push(bubble);
    },
    setAuthenticated(state, authenticated) {
      state.authenticated = authenticated;
    },
  },
  actions: {},
  modules: {},
});
